/*
 * gsk-whatsapp.js - Scroll-Reveal fuer den schwebenden WhatsApp-Button.
 * Spiegelt das CMS-Frontend (golfsimulator.kaufen): der FAB ist am Hero
 * versteckt und erscheint, sobald man past Hero / ueber die zweite Section
 * gescrollt hat. Geschaltet wird ueber die body-Klasse 'gsk-chat-visible'
 * (CSS in gsk-brand.css, Abschnitt GSK WHATSAPP-FAB).
 *
 * Primaerweg: IntersectionObserver auf den GSK-Hero (.gsk-hero-section). Sobald
 * der Hero den Viewport-Top verlaesst (nicht mehr sichtbar), wird der FAB
 * eingeblendet. Fallback (keine erste Hero-Section, z.B. einfache Unterseite):
 * scrollY-Schwelle ueber ~70% der Viewport-Hoehe, via requestAnimationFrame.
 *
 * Das Sichtbar-Schalten selbst ist KEINE Animation -> reduced-motion muss hier
 * nichts unterdruecken (die Slide/Scale-Animation regelt das CSS).
 */
(function () {
  'use strict';

  var BODY_CLASS = 'gsk-chat-visible';

  function reveal() {
    document.body.classList.add(BODY_CLASS);
  }
  function hide() {
    document.body.classList.remove(BODY_CLASS);
  }

  function initObserver(hero) {
    // Sentinel-Beobachtung: solange der Hero (auch nur teilweise) sichtbar ist,
    // FAB verstecken; sobald er ganz raus ist (past Hero), FAB zeigen.
    if (!('IntersectionObserver' in window)) {
      return initScrollFallback();
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            hide();
          } else {
            reveal();
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -10% 0px' }
    );
    observer.observe(hero);
  }

  function initScrollFallback() {
    var ticking = false;
    function update() {
      ticking = false;
      var threshold = window.innerHeight * 0.7;
      if (window.scrollY > threshold) {
        reveal();
      } else {
        hide();
      }
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    if (!document.querySelector('.gsk-chat')) return; // FAB nicht im DOM
    var hero = document.querySelector('.gsk-hero-section');
    if (hero) {
      initObserver(hero);
    } else {
      initScrollFallback();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Shopify Theme-Editor: Section-Re-Render (FAB neu eingehaengt)
  document.addEventListener('shopify:section:load', init);
})();
